import Layout from "./components/layout/Layout";
import HomePage from "./components/pages/HomePage";
import ProductsPage from "./components/pages/ProductsPage";
import { useDocumentMeta } from "./hooks/useDocumentMeta";
import { useRoute } from "./hooks/useRoute";

const routes = {
  "/": {
    title: "Technie | Building products that solve real problems",
    description:
      "Technie is an independent technology studio creating practical products for students, professionals, and everyday users.",
    component: HomePage
  },
  "/products": {
    title: "Products | Technie",
    description:
      "Explore current and upcoming products from Technie, including student platforms, AI tools, mobile apps, developer tools, and SaaS products.",
    component: ProductsPage
  }
};

function App() {
  const { path, navigate } = useRoute();
  const route = routes[path] || routes["/"];
  const Page = route.component;

  useDocumentMeta(route);

  return (
    <Layout currentPath={path} onNavigate={navigate}>
      <Page onNavigate={navigate} />
    </Layout>
  );
}

export default App;
